/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Home_Footer_Link_AboutInputs */

const en_home_footer_link_about = /** @type {(inputs: Home_Footer_Link_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.companyName}`)
};

const fr_home_footer_link_about = /** @type {(inputs: Home_Footer_Link_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À propos de ${i?.companyName}`)
};

/**
* | output |
* | --- |
* | "About {companyName}" |
*
* @param {Home_Footer_Link_AboutInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_about = /** @type {((inputs: Home_Footer_Link_AboutInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_AboutInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_about(inputs)
	return fr_home_footer_link_about(inputs)
});